import {Alert, Anchor} from '@mantine/core'

import {getStoredUser} from 'src/lib/auth'

import {useScenarioPlanning} from './scenario-context'

/** Banner when an admin has an active scenario; clearing resets analytics to live defaults. */
export function ScenarioActiveBanner() {
    const user = getStoredUser()
    const scenario = useScenarioPlanning()

    if (!user?.is_admin || !scenario.hasOverrides) {
        return null
    }

    return (
        <Alert
            color="green"
            variant="light"
            mb="md"
            title="Scenario mode active"
            withCloseButton
            onClose={scenario.resetToDefaults}
        >
            Analytics on this site reflect your adjusted thresholds and conversion rates.{' '}
            <Anchor
                component="button"
                type="button"
                c="green"
                onClick={scenario.resetToDefaults}
                style={{background: 'none', border: 'none', padding: 0, cursor: 'pointer'}}
            >
                Clear scenario
            </Anchor>
        </Alert>
    )
}
